import type { Question } from '../instrument'

export type IFormId = string

export interface IForm {
  id: IFormId
  name: string
  updatedAt: string
  version: string
  questions: Question[]
}

export type IQuestionId = string
export type IQuestionOptionValue = string

export interface IQuestionOption {
  name: string
  value: string
}

export enum QuestionValidationType {
  DisallowDateInFuture = 'disallow-date-in-future',
  ValidateEmail = 'validate-email-input',
  ValidateInteger = 'validate-integer-input',
  ValidatePhoneNumber = 'validate-phone-input',
  ValidateYear = 'validate-year-input',
}

export type QuestionValidation = {
  type:
    | QuestionValidationType.DisallowDateInFuture
    | QuestionValidationType.ValidateEmail
    | QuestionValidationType.ValidateInteger
    | QuestionValidationType.ValidatePhoneNumber
    | QuestionValidationType.ValidateYear
}

export type IAnswerId = string

export interface IAnswer {
  id: IAnswerId
  questionId: IQuestionId
  value: IQuestionOptionValue
}

export type UnitRecord = {
  value?: string
  unit?: string
}
